// eslint-disable-next-line no-undef
tinymce.PluginManager.add('groove-emojis', editor =>
  editor.on('emoji-insert', e => editor.insertContent(e.emoji))
)
